import React, { Component, Fragment } from 'react';
import { Table } from 'react-bootstrap';
import EllipsisText from "react-ellipsis-text";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { convertDate, formatAMPM } from '../../../utils/miscelleneous';
import { TopicLoader } from '../../../Loader/loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { resetLoading, getConversationList, getNextConversationList } from '../../../ActionCreators/AdminAction/managementorAction';
import { clearErrors } from '../../../ActionCreators/errorAction';
import '../mentors.scss';
import Snackbar from '@mui/material/Snackbar';

class Conversation extends Component {
    state = {
        pageCount: 1
    }


    componentDidMount = () => {
        this.props.getConversationList(this.state.pageCount);
    }

    fetchConversationData = () => {
        this.setState({
            pageCount: this.state.pageCount + 1
        }, () => {
            this.props.getNextConversationList(this.state.pageCount)
        })
    }

    snackClosed = () => {
        this.props.clearErrors();
    }



    render() {
        const { conversation, isLoading, successEnable, successMessage, successMessageText } = this.props
        return (
            <div>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Fragment>
                    <div className='qna-search'>
                        {/* <div className="mentor-search"  >
                                            <span className="form-control-feedback">
                                                <img src="/images/search.svg" width="14" alt='' />
                                            </span>
                                            <input placeholder={'Search For Mentor'} id='search' autoComplete='off'
                                                // onChange={(e) => this.querySearch(e.target.value)} 
                                                value={this.state.querySearch} className='form-control' />
                                        </div> */}

                    </div>
                    {isLoading ?
                        <div>
                            <TopicLoader />
                        </div>
                        :
                        <div className="table-admin" >
                            <InfiniteScroll
                                dataLength={conversation !== undefined && conversation?.length} //This is important field to render the next data
                                next={this.fetchConversationData}
                                hasMore={true}
                            // style={{ overflowX: 'hidden' }}
                            >
                                <Table responsive >
                                    <thead>
                                        <tr className="header-table" style={{ backgroundColor: "#fff" }}>
                                            {/* {window.innerWidth > 767 ? <th></th> : null} */}
                                            <th>Query</th>
                                            <th className='text-center'>From</th>
                                            <th>{'Skill'} </th>
                                            <th className='text-center'>Status</th>
                                            <th className='text-center'>Created</th>
                                            <th className='text-center'>Updated</th>
                                            <th className='text-center'>Action</th>
                                        </tr>

                                    </thead>
                                    <tbody className="table-body" >
                                        {
                                            (conversation !== "" && conversation !== undefined && conversation.length > 0 ?
                                                conversation.map((el, i) => {
                                                    return (
                                                        <tr key={i} className='cursor-pointer'
                                                            onClick={() => this.props.goToDetails(el)}
                                                        >
                                                            {/* {window.innerWidth > 767 ? <td>{el.new ? <img src='/images/point.svg' style={{ verticalAlign: 'middle' }} alt='' /> : ''}</td> : null} */}

                                                            <td style={{ width: '30%', textAlign: 'left' }}><EllipsisText text={el.question} length={window.innerWidth > 767 ? "120" : '90'} /></td>
                                                            <td>{el.name}</td>
                                                            <td > <div className='d-flex'>
                                                                <p className='text-capitalize'>{el.skill?.title}</p></div></td>
                                                            <td className='text-center'>{el.closed ? 'Closed' : 'In Progress'}</td>
                                                            <td className='text-center'>{convertDate(el.createdAt)}<br />{formatAMPM(el.createdAt)}</td>
                                                            <td className='text-center'>{convertDate(el.updatedAt)}<br />{formatAMPM(el.updatedAt)}</td>
                                                            <td className='text-center'><img src='/images/arrow-up-grey.svg' alt='' className='arrow-rotate' /></td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr >
                                                    <td colSpan="6">
                                                        <div className='empty-list'>
                                                            <img src='/images/empty.png' alt='' />
                                                            <p>There is no query/conversation currently available for you</p>
                                                        </div>
                                                    </td>

                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                            </InfiniteScroll>
                        </div>

                    }
                </Fragment>

            </div>
        )
    }
}


const mapStateToProps = (state) => {
    const { isLoading, conversation } = state.manageMentor
    const { successEnable, successMessage, successMessageText } = state.error
    return {
        isLoading, conversation,
        successEnable, successMessage, successMessageText
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ resetLoading, getConversationList, getNextConversationList, clearErrors }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversation)
